import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ArrowDown, CheckCircle } from 'lucide-react';
interface SolutionSectionProps {
  id: string;
  title: string;
  whatThisSolves: string;
  howObseqIsUsed: string[];
  productsUsed: string[];
  icon: React.ElementType;
  reverse?: boolean;
}
// Solution-specific diagrams
const FintechDiagram = () => <div className="w-full" data-id="element-619">
    {/* Desktop */}
    <div className="hidden sm:flex items-center justify-between gap-2 mb-8" data-id="element-620">
      {['Client App', 'Obseq APIs', 'Products', 'Rails'].map((step, i) => <Fragment key={i} data-id="element-621">
          <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: i * 0.05
      }} className={`${i === 1 ? 'bg-blue-600 text-white' : 'bg-white border-2 border-slate-300 text-slate-700'} rounded-lg p-4 text-center flex-1`} data-id="element-622">
            <span className="text-sm font-semibold" data-id="element-623">{step}</span>
          </motion.div>
          {i < 3 && <ArrowRight className="w-5 h-5 text-slate-400 flex-shrink-0" data-id="element-624" />}
        </Fragment>)}
    </div>
    {/* Mobile */}
    <div className="sm:hidden grid grid-cols-2 gap-3 mb-6" data-id="element-625">
      {['Client App', 'Obseq APIs', 'Products', 'Rails'].map((step, i) => <motion.div key={i} initial={{
      opacity: 0,
      scale: 0.9
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} transition={{
      delay: i * 0.05
    }} className={`${i === 1 ? 'bg-blue-600 text-white' : 'bg-white border-2 border-slate-300 text-slate-700'} rounded-lg p-4 text-center`} data-id="element-626">
            <span className="text-sm font-semibold" data-id="element-627">{step}</span>
          </motion.div>)}
    </div>
    <motion.div initial={{
    opacity: 0,
    y: 10
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    delay: 0.3
  }} className="grid grid-cols-3 gap-2" data-id="element-628">
      {['Wallets', 'Payments', 'Exchange'].map((product, i) => <div key={i} className="bg-slate-100 border border-slate-300 rounded p-2 text-center" data-id="element-629">
          <span className="text-xs font-medium text-slate-700" data-id="element-630">{product}</span>
        </div>)}
    </motion.div>
  </div>;
const MarketplaceDiagram = () => <div className="w-full" data-id="element-631">
    {/* Desktop */}
    <div className="hidden sm:flex items-center justify-between gap-3 mb-8" data-id="element-632">
      {['Buyer', 'Marketplace', 'Wallets', 'Payouts'].map((step, i) => <Fragment key={i} data-id="element-633">
          <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: i * 0.05
      }} className="bg-white border-2 border-slate-300 rounded-lg p-4 text-center flex-1" data-id="element-634">
            <span className="text-sm font-semibold text-slate-700" data-id="element-635">{step}</span>
          </motion.div>
          {i < 3 && <ArrowRight className="w-5 h-5 text-slate-400 flex-shrink-0" data-id="element-636" />}
        </Fragment>)}
    </div>
    {/* Mobile */}
    <div className="sm:hidden grid grid-cols-2 gap-3 mb-6" data-id="element-637">
      {['Buyer', 'Marketplace', 'Wallets', 'Payouts'].map((step, i) => <motion.div key={i} initial={{
      opacity: 0,
      scale: 0.9
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} transition={{
      delay: i * 0.05
    }} className="bg-white border-2 border-slate-300 rounded-lg p-4 text-center" data-id="element-638">
            <span className="text-sm font-semibold text-slate-700" data-id="element-639">{step}</span>
          </motion.div>)}
    </div>
    <motion.div initial={{
    opacity: 0,
    y: 10
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    delay: 0.3
  }} className="bg-red-50 border border-red-200 rounded-lg p-3 text-center" data-id="element-640">
      <span className="text-sm font-semibold text-red-700" data-id="element-641">
        Compliance (Inline)
      </span>
    </motion.div>
  </div>;
const TreasuryDiagram = () => <div className="w-full" data-id="element-642">
    {/* Desktop */}
    <div className="hidden sm:flex items-center justify-between gap-3 mb-8" data-id="element-643">
      {['Local Collections', 'FX Conversion', 'Central Treasury', 'Global Payouts'].map((step, i) => <Fragment key={i} data-id="element-644">
          <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: i * 0.05
      }} className="bg-white border-2 border-slate-300 rounded-lg p-4 text-center flex-1" data-id="element-645">
            <span className="text-xs font-semibold text-slate-700" data-id="element-646">{step}</span>
          </motion.div>
          {i < 3 && <ArrowRight className="w-5 h-5 text-slate-400 flex-shrink-0" data-id="element-647" />}
        </Fragment>)}
    </div>
    {/* Mobile */}
    <div className="sm:hidden grid grid-cols-2 gap-3 mb-6" data-id="element-648">
      {['Local Collections', 'FX Conversion', 'Central Treasury', 'Global Payouts'].map((step, i) => <motion.div key={i} initial={{
      opacity: 0,
      scale: 0.9
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} transition={{
      delay: i * 0.05
    }} className="bg-white border-2 border-slate-300 rounded-lg p-4 text-center" data-id="element-649">
            <span className="text-xs font-semibold text-slate-700" data-id="element-650">{step}</span>
          </motion.div>)}
    </div>
    <motion.div initial={{
    opacity: 0,
    y: 10
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    delay: 0.3
  }} className="text-center text-sm text-slate-500" data-id="element-651">
      Liquidity sources feed FX execution
    </motion.div>
  </div>;
const PayrollDiagram = () => <div className="w-full" data-id="element-652">
    {/* Desktop */}
    <div className="hidden sm:flex items-center justify-between gap-2" data-id="element-653">
      {['Employer', 'Payroll Engine', 'FX', 'Local Rails', 'Recipients'].map((step, i) => <Fragment key={i} data-id="element-654">
            <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: i * 0.05
      }} className="bg-white border-2 border-slate-300 rounded-lg p-3 text-center flex-1" data-id="element-655">
              <span className="text-xs font-semibold text-slate-700" data-id="element-656">
                {step}
              </span>
            </motion.div>
            {i < 4 && <ArrowRight className="w-4 h-4 text-slate-400 flex-shrink-0" data-id="element-657" />}
          </Fragment>)}
    </div>
    {/* Mobile */}
    <div className="sm:hidden space-y-3" data-id="element-658">
      {['Employer', 'Payroll Engine', 'FX', 'Local Rails', 'Recipients'].map((step, i) => <Fragment key={i} data-id="element-659">
            <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: i * 0.05
      }} className="bg-white border-2 border-slate-300 rounded-lg p-4 text-center" data-id="element-660">
              <span className="text-sm font-semibold text-slate-700" data-id="element-661">
                {step}
              </span>
            </motion.div>
            {i < 4 && <div className="flex justify-center" data-id="element-662">
              <ArrowDown className="w-5 h-5 text-slate-400" data-id="element-663" />
            </div>}
          </Fragment>)}
    </div>
  </div>;
const ProgrammableDiagram = () => <div className="w-full" data-id="element-664">
    {/* Desktop */}
    <div className="hidden sm:flex items-center justify-between gap-3 mb-8" data-id="element-665">
      {['Mint', 'Hold', 'Transfer', 'Settle'].map((step, i) => <Fragment key={i} data-id="element-666">
          <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: i * 0.05
      }} className="bg-white border-2 border-slate-300 rounded-lg p-4 text-center flex-1" data-id="element-667">
            <span className="text-sm font-semibold text-slate-700" data-id="element-668">{step}</span>
          </motion.div>
          {i < 3 && <ArrowRight className="w-5 h-5 text-slate-400 flex-shrink-0" data-id="element-669" />}
        </Fragment>)}
    </div>
    {/* Mobile */}
    <div className="sm:hidden grid grid-cols-2 gap-3 mb-6" data-id="element-670">
      {['Mint', 'Hold', 'Transfer', 'Settle'].map((step, i) => <motion.div key={i} initial={{
      opacity: 0,
      scale: 0.9
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} transition={{
      delay: i * 0.05
    }} className="bg-white border-2 border-slate-300 rounded-lg p-4 text-center" data-id="element-671">
            <span className="text-sm font-semibold text-slate-700" data-id="element-672">{step}</span>
          </motion.div>)}
    </div>
    <motion.div initial={{
    opacity: 0,
    y: 10
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    delay: 0.3
  }} className="bg-purple-50 border border-purple-200 rounded-lg p-3 text-center" data-id="element-673">
      <span className="text-sm font-semibold text-purple-700" data-id="element-674">
        Rules Applied
      </span>
    </motion.div>
  </div>;
export function SolutionSection({
  id,
  title,
  whatThisSolves,
  howObseqIsUsed,
  productsUsed,
  icon: Icon,
  reverse = false
}: SolutionSectionProps) {
  const renderDiagram = () => {
    switch (id) {
      case 'fintech-psp':
        return <FintechDiagram data-id="element-675" />;
      case 'marketplaces':
        return <MarketplaceDiagram data-id="element-676" />;
      case 'treasury':
        return <TreasuryDiagram data-id="element-677" />;
      case 'payroll':
        return <PayrollDiagram data-id="element-678" />;
      case 'programmable':
        return <ProgrammableDiagram data-id="element-679" />;
      default:
        return <FintechDiagram data-id="element-680" />;
    }
  };
  return <section id={id} className="py-20 border-b border-slate-100 scroll-mt-20" data-id="element-681">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-682">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16" data-id="element-683">
          {/* Content Column */}
          <div className={`lg:col-span-6 flex flex-col justify-start ${reverse ? 'lg:col-start-7' : ''}`} data-id="element-684">
            {/* Title */}
            <div className="flex flex-col sm:flex-row items-center sm:items-center gap-3 mb-4 text-center sm:text-left" data-id="element-685">
              <div className="w-10 h-10 rounded-lg bg-blue-50 flex items-center justify-center text-blue-600" data-id="element-686">
                <Icon className="w-5 h-5" data-id="element-687" />
              </div>
              <h2 className="text-2xl sm:text-3xl font-bold text-slate-900" data-id="element-688">{title}</h2>
            </div>

            {/* What This Solves */}
            <div className="mb-8 sm:mb-10 text-center sm:text-left" data-id="element-689">
              <h3 className="text-xs font-semibold text-slate-900 uppercase tracking-wider mb-3" data-id="element-690">
                What This Solves
              </h3>
              <p className="text-base sm:text-lg text-slate-600 leading-relaxed" data-id="element-691">
                {whatThisSolves}
              </p>
            </div>

            {/* How Obseq Is Used */}
            <div className="mb-8 sm:mb-10 text-center sm:text-left" data-id="element-692">
              <h3 className="text-xs font-semibold text-slate-900 uppercase tracking-wider mb-4" data-id="element-693">
                How Obseq Is Used
              </h3>
              <div className="relative pl-6 border-l-2 border-slate-100 space-y-4" data-id="element-694">
                {howObseqIsUsed.map((item, index) => <div key={index} className="relative" data-id="element-695">
                    <div className="absolute -left-[29px] top-0 w-4 h-4 rounded-full bg-white border-2 border-blue-500 flex items-center justify-center" data-id="element-696">
                      <div className="w-1.5 h-1.5 rounded-full bg-blue-500" data-id="element-697" />
                    </div>
                    <p className="text-sm text-slate-700 font-medium" data-id="element-698">{item}</p>
                  </div>)}
              </div>
            </div>

            {/* Products Used */}
            <div className="text-center sm:text-left" data-id="element-699">
              <h3 className="text-xs font-semibold text-slate-900 uppercase tracking-wider mb-3" data-id="element-700">
                Products Used
              </h3>
              <div className="flex flex-wrap justify-center sm:justify-start gap-2" data-id="element-701">
                {productsUsed.map((product, index) => <span key={index} className="inline-flex items-center px-3 py-1.5 rounded-full bg-blue-50 border border-blue-100 text-xs font-medium text-blue-700" data-id="element-702">
                    {product}
                  </span>)}
              </div>
            </div>
          </div>

          {/* Diagram Column */}
          <div className={`lg:col-span-6 flex items-start ${reverse ? 'lg:col-start-1 lg:row-start-1' : ''}`} data-id="element-703">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4
          }} className="w-full bg-slate-50 rounded-xl border border-slate-200 p-6 sm:p-8 flex items-center justify-center min-h-[300px]" data-id="element-704">
              <div className="w-full max-w-lg" data-id="element-705">{renderDiagram()}</div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}